import { render, staticRenderFns } from "./UserSettingPageSender.vue?vue&type=template&id=09a6af53&scoped=true&"
import script from "./UserSettingPageSender.vue?vue&type=script&lang=js&"
export * from "./UserSettingPageSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6af53",
  null
  
)

export default component.exports